// Protocol statuses. Mirror of backend/modules/protocols/models.
export enum ProtocolStatus {
  Draft = 'draft',
  Pending = 'pending',
  Published = 'published',
  Retired = 'retired',
}

export enum Severity {
  Warning = 'warning',
  Alarm = 'alarm',
}

// Evaluation types listed by #3189.
export enum RuleOperator {
  Equal = 'eq',
  NotEqual = 'neq',
  Greater = 'gt',
  Lower = 'lt',
  GreaterEqual = 'gte',
  LowerEqual = 'lte',
  TrendUp = 'trend_up',
  TrendDown = 'trend_down',
  // Membership: the value carries the comma-separated list.
  In = 'in',
}

// Type of the value the rule compares against.
export enum RuleValueType {
  Num = 'num',
  String = 'string',
  List = 'list',
}

// Measured parameters the engine supports today.
export const MEASURED_PARAMETERS = [
  'heart_rate',
  'steps',
  'spo2',
  'sleep_minutes',
  'calories',
  'active_minutes',
]

export type Rule = {
  id: string
  ruleSetID: string
  parameter: string
  operator: RuleOperator
  valueType: RuleValueType
  value: string
  sampleSize: number | null
  intervalMinutes: number | null
}

export type RuleSet = {
  id: string
  protocolID: string
  name: string
  notificationMessage: string
  severity: Severity
  rules: Rule[]
}

export type Protocol = {
  id: string
  name: string
  description: string
  status: ProtocolStatus
  version: number
  previousID: string | null
  approverID: string | null
  approvedAt: string | null
  createdAt: string
  updatedAt: string
  ruleSets: RuleSet[]
}

// Protocolo que le llega al paciente por una de sus patologias. Es derivado:
// desde la #3185 nadie asigna protocolos a mano.
export type PatientProtocol = {
  protocolID: string
  pathologyID: string
}

export type ProtocolPathology = {
  id: string
  protocolID: string
  pathologyID: string
}

export type Evaluation = {
  id: string
  patientID: string
  ruleSetID: string
  triggered: boolean
  details: string
  notificationSent: boolean
  evaluatedAt: string
}

// Serialised detail the engine stores on every evaluation.
export type EvaluationDetail = {
  parameter: string
  operator: string
  reference: string
  values?: number[]
  answers?: string[]
  met: boolean
  reason?: string
}

export type ImportError = {
  row: number
  column: string
  message: string
}

export type ImportResult = {
  protocol?: Protocol
  ruleSets: number
  rules: number
  errors: ImportError[]
}
